/* eslint-disable import/prefer-default-export */
import { Moment } from 'moment';

export const getClassJoinTimeStatusData = (
  startTime: Moment,
  joinTime: Moment
) => {
  let badgeData: { text: string; color: 'info' | 'warning' } = {
    text: 'On Time',
    color: 'info',
  };

  if (startTime && joinTime) {
    if (
      joinTime.isBefore(startTime) ||
      joinTime.diff(startTime, 'minutes') < 1
    ) {
      badgeData = {
        text: 'On Time',
        color: 'info',
      };
    } else if (joinTime.diff(startTime, 'minutes') >= 1) {
      const _mins = joinTime.diff(startTime, 'minutes');
      badgeData = {
        text: `${_mins} Minute${_mins > 1 ? 's' : ''} Late`,
        color: 'warning',
      };
    }
  }

  return badgeData;
};
